import { expandSettings } from '@4r/module-common-mf-app';
import { Settings } from '../contexts/types';

const settingsPath = `${process.env.PUBLIC_URL}/config.json`;

let pending: Promise<Settings> | null = null;

async function fetchSettings(): Promise<Settings> {
	const response = await fetch(settingsPath);
	if (!response.ok) {
		throw new Error(`Failed to load ${settingsPath}: ${response.status} ${response.statusText}`);
	}

	const contentType = response.headers.get('content-type');
	if (contentType === null || contentType.indexOf('json') === -1) {
		throw new Error(`Unexpected content-type for ${settingsPath}: ${contentType}`);
	}

	return expandSettings(await response.json()) as Settings;
}

/**
 * Memoised config.json load. index.tsx needs the Faro collector URL before the first render
 * and App needs the full settings object after it; sharing one promise keeps that to a single
 * request instead of two.
 */
export default function loadSettings(): Promise<Settings> {
	if (!pending) {
		pending = fetchSettings();
	}
	return pending;
}
